import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import * as io from 'socket.io-client';
import { AuthService } from './auth.service';
import { User } from '../../pages/professor-portal/professors/professor.model';
import { ChatP } from '../../pages/chat/chat.model';

export class SocketService {
  private url = 'https://admin.cnci.mx';  
  public socket;
  static instance: SocketService = null;
  static isCreating: boolean = false;
  static userStatus: number = 0;

  constructor () {

    if (!SocketService.isCreating) {
      throw new Error("This is a real singleton. Get an instance via var socket = NodoSocket.getInsance(); !");
    }

    console.info("creating socket object");

    const user = JSON.parse(sessionStorage.getItem('user'));
    //Se agrego el Usuario con procos parametros, ya que el Socket no respondia con el json del usuario completo
    const shortUser = {
      id: user.id,
      name: user.name,
      lastname: user.lastname,
      username: user.username,
      status : user.status,
    }
    user['status'] = 1;
    this.socket = io(this.url, {secure: true, path: '/chatsocket/socket.io', query: {user: JSON.stringify(shortUser)}});
    //this.socket = io(this.url, {secure: true, path: '/chatsocket/socket.io', query: {user: '{"name":"Oscar","lastname":"Perez","username":"oscar", "status": "1"}'}});

    console.info("establishing connection to server...");
    console.info(sessionStorage.getItem('isLoggedIn'));

    // this.socket.on('connect', function (data) {
    //   console.log('I am connected');
    //   debugger
    // });
     this.socket.connect();
  }
  
  sendTyping(data: any = null){
    console.log('emiting socket > typing');
    console.log(data);
    this.socket.emit('typing', data);    
  }
  
  sendStopTyping(data: any = null){
    console.log('emiting socket > stop-typing');
    this.socket.emit('stop-typing', data);    
  }
  
  sendNewChatMessage(data: any = null){
    console.log('emiting socket > new-chat-message');
    this.socket.emit('new-chat-message', data);    
  }
  
  getPresences(data: any = null){
    console.log('emiting socket > get-presences');
    this.socket.emit('get-presences', data);    
  }
  
  sendNewProcedure(data: any = null){
    console.log('emiting socket > new-procedure');
    this.socket.emit('new-procedure', data);    
  }
  
  login(data: any = null){
    console.log('emiting socket > login');
    this.socket.emit('connected', data);    
  }
  
  sendNewAnswerProcedure(data: any = null){
    console.log('emiting socket > new-answer-procedure');
    this.socket.emit('new-answer-procedure', data);    
  }
  
  sendUpdatedViewedProcedure(data: any = null){
    console.log('emiting socket > updated-viewed-procedure');
    this.socket.emit('updated-viewed-procedure', data);    
  }
  
  sendStatus(data: any = null){
    console.log('emiting socket > new-status');
    this.socket.emit('new-status', data);    
  }
  
  sendMarkMessageSeen(data: any = null){
    console.log('emiting socket > mark-message-seen');
    this.socket.emit('mark-message-seen', data);    
  }
  
  sendMarkMessageReceived(data: any = null){
    console.log('emiting socket > mark-message-received');
    this.socket.emit('mark-message-received', data);    
  }

  onNewStatus() {
    let observable = new Observable<User>(observer => {
      this.socket.on('new-status', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  onTyping() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('typing', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  onStopTyping() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('stop-typing', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  testDiscon() {
    let observable = new Observable(observer => {
      this.socket.on('test-discon', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  onDisconnected() {
    let observable = new Observable<User>(observer => {
      this.socket.on('user-disconnected', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  onConnected() {
    let observable = new Observable<User>(observer => {
      this.socket.on('user-connected', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  onConnection() {
    let observable = new Observable<User>(observer => {
      this.socket.on('connect', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  newProcedure() {
    let observable = new Observable(observer => {
      this.socket.on('new-procedure', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  newAnswerProcedure() {
    let observable = new Observable(observer => {
      this.socket.on('new-answer-procedure', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }  

  updatedViewedProcedure() {
    let observable = new Observable(observer => {
      this.socket.on('updated-viewed-procedure', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  onReceivePresence() {
    let observable = new Observable<User>(observer => {
      this.socket.on('send-presence', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  onNewChatMessage() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('new-chat-message', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  onActiveNewChatMessage() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('new-active-chat-message', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  onMarkMessageSeen() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('mark-message-seen', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  onMarkMessageReceived() {
    let observable = new Observable<ChatP>(observer => {
      this.socket.on('mark-message-received', (data) => {
        observer.next(data);    
      });
      return () => {
        this.socket.disconnect();
      };  
    })     
    return observable;
  }

  disconnect(): any {
    this.socket.disconnect();
    this.socket = null;
    SocketService.instance = null;
  }

  initListeners() {
    SocketService.instance.onDisconnected().subscribe(user => {
      console.log(user.username + ' is disconnected');
    });

    SocketService.instance.onConnected().subscribe(user => {
        console.log(user.username + ' is connected');

    });

    

    // SocketService.instance.onNewChatMessage().subscribe(message => {
    //     console.log('New chat message <' + message.message + '> from ' + message.from.username + ' para ' + message.to.username);
    // });
  }

  static getInstance(): SocketService {
    if (SocketService.instance === null) {
      // if(sessionStorage.getItem('isLoggedIn')) {
        SocketService.isCreating = true;
        SocketService.instance = new SocketService();
        SocketService.isCreating = false;
      // }
    }

    console.log("NodoSocket.instance", SocketService.instance);
    return SocketService.instance;
  }
}